<ion-content class="md-page md-padded ly-col" *mobxAutorun>
  <ion-row class="ion-margin-bottom ion-align-items-center filters-container">
    <ion-item class="ion-margin-end ion-hide">
      <ion-label position="stacked" class="ion-text-capitalize">
        {{ 'show' | translate}}
      </ion-label>
      <ion-select
        (ionChange)="_perPageSelected = $any($event).detail.value"
        [value]="_perPageSelected"
        [interfaceOptions]="{
          size: 'auto',
          alignment: 'start'
        }"
        class="ion-text-capitalize"
      >
        <ion-select-option
          *ngFor="let perPage of perPageOptions"
          [value]="perPage"
          class="ion-text-capitalize"
        >
          {{ perPage + " Entries"| translate }}
        </ion-select-option>
      </ion-select>
    </ion-item>

    <date-input
      label="startText"
      [value]="_startDate"
      (ionChangeDate)="applyFilter($any($event), DATA_FROM.STARTDATESELECT)"
      class="ion-margin-end"
    >
    </date-input>

    <date-input
      label="endText"
      [value]="_endDate"
      (ionChangeDate)="applyFilter($any($event), DATA_FROM.ENDDATESELECT)"
    >
    </date-input>

    <ns-select
      class="ion-margin-horizontal"
      [placeholder]="'workspace.leaderboard.labels.teamsPlaceholder' | translate"
      [label]="'filterByText' | translate"
      [disabled]="!!getTeamsSubscription"
      [items]="teams!"
      [value]="_selectedTeam"
      (ionChange)="applyFilter($any($event), DATA_FROM.SELECTEDTEAMSELECT)"
    >
    </ns-select>

    <ion-searchbar
      (ionChange)="applyFilter($any($event).detail.value, DATA_FROM.SEARCH)"
      class="md-alt"
    >
    </ion-searchbar>
  </ion-row>

  <leaderboard-viewer
    [fullView]="true"
    [startDate]="startDate"
    [endDate]="endDate"
    [teamIds]="selectedTeamsIds"
    [teamMemberName]="teamMemberName"
    [perPage]="perPageSelected"
  >
  </leaderboard-viewer>
</ion-content>
